export default __webpack_public_path__ + "static/media/GrandfatherClock.7332c721.png";